import { useEnquiryModal } from '~/modules-rocco/enquiry/hooks/use-enquiry-modal';
import { ProfileCard } from './ProfileCard';
import { ProfileDetailCard } from './ProfileDetailCard';
import type {
    DisplayMember,
    ProfessionalMessageProps,
    ProjectTeamMemberDetailProps,
} from './types';
import { useMemo } from 'react';
import { createEnquiryProfessional } from './utils';
/**
 * Displays detailed information about a selected team member with profile card and details
 */
export const ProjectTeamMemberDetail = ({
    currentMember,
    currentTeamMember,
    teamMembers,
    handlePrev,
    handleNext,

    showNavigation = false,
}: ProjectTeamMemberDetailProps) => {
    // Create a ProfessionalMessageProps object for enquiry modal
    const professionalProps: ProfessionalMessageProps = {
        ID: currentTeamMember.ProfessionalID,
        Title: currentTeamMember.JobTitle,
        Link: currentTeamMember.Link || '',
        CompanyLogo: currentTeamMember.CompanyLogo || '',
        LibraryLocations: currentTeamMember.LibraryLocations || [],
        LogoBackgroundColor: currentTeamMember.LogoBackgroundColor || '',
        branchOptions: currentTeamMember.BranchOptions || [],
        ArchiproEditorialAccount:
            currentTeamMember.ArchiproEditorialAccount || '',
        CustomEnquiryMessage: currentTeamMember.CustomEnquiryMessage || '',
        AvailableForWork: currentTeamMember.AvailableForWork || false,
    };

    // Create a MemberForDisplay for the current selected team member
    const displayMember = useMemo((): DisplayMember => {
        return {
            name: currentTeamMember.Name,
            jobTitle: currentTeamMember.JobTitle,
            detailsPageImageSrc: currentTeamMember.Thumbnail,
            category: currentMember.Category,
            professionalId: currentTeamMember.ProfessionalID,
            professionalName: currentTeamMember.ProfessionalName,
        };
    }, [currentTeamMember, currentMember]);
    // Initialize enquiry modal hook
    const { openEnquiryModal } = useEnquiryModal({
        professional: createEnquiryProfessional(professionalProps),
        title: currentTeamMember.Name,
        itemType: 'professional',
        siteTreeID: professionalProps.ID, // professiona id
    });
    // Transform all team members for the ProfileCard component
    const displayFilteredMembers = useMemo((): DisplayMember[] => {
        return teamMembers.map((member) => ({
            name: member.Name,
            jobTitle: member.JobTitle,
            detailsPageImageSrc: member.Thumbnail,
            category: currentMember.Category,
            professionalId: member.ProfessionalID,
            professionalName: member.ProfessionalName,
        }));
    }, [teamMembers, currentMember]);

    if (!displayMember || !currentTeamMember) {
        return null;
    }

    return (
        <div
            key={currentTeamMember.ID}
            className="flex w-full flex-row gap-[12.5rem]"
        >
            {/* Profile Card Section */}
            <ProfileCard
                member={displayMember}
                filteredMembers={displayFilteredMembers}
                handlePrev={handlePrev}
                handleNext={handleNext}
                showNavigation={showNavigation}
            />

            {/* Profile Detail Card Section */}
            <ProfileDetailCard
                key={currentTeamMember.ID}
                name={currentTeamMember.Name}
                summary={currentTeamMember.Summary}
                nzrab={currentTeamMember.NZRAB}
                id={currentTeamMember.ID}
                professionalId={currentTeamMember.ProfessionalID}
                onMessageClick={() => openEnquiryModal()}
                professionalProps={professionalProps}
                category={currentMember.Category}
            />
        </div>
    );
};
